<template>
  <div class="dispo-wrap">

    <!-- Header -->
    <div class="dispo-header">
      <div class="dispo-header-left">

        <div class="select-wrap">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
          </svg>
          <select v-model="lieu" class="form-select" @change="getDateDispoByLieu">
            <option value="">Lieu</option>
            <template v-for="l in lieux" :key="l.id">
              <option :value="l.id">{{ l.nom }}</option>
            </template>
          </select>
        </div>

        <template v-if="jours != ''">
          <div class="calendar-wrap">
            <calendar v-model="date" dateFormat="dd/mm/yy" @date-select="onDateSelect(0, mode)">
              <template #date="slotProps">
                <span
                  v-if="jours.includes(formatDate(slotProps.date))"
                  class="underlined-day"
                >
                  {{ slotProps.date.day }}
                </span>
                <span v-else>{{ slotProps.date.day }}</span>
              </template>
            </calendar>
          </div>

          <div class="select-wrap">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
            </svg>
            <select v-model="mode" class="form-select" @change="changeLieuMono">
              <option value="null">Moniteurs</option>
              <template v-for="m in moniteurs" :key="m.id">
                <option :value="m.idMono">{{ m.surnom }}</option>
              </template>
            </select>
          </div>
        </template>

      </div>
    </div>

    <!-- Table -->
    <div class="table-card" v-if="laDate !== ''">
      <DataTable :value="dispos" tableStyle="width: 100%" :rows="10" @click="onSelected" selectionMode="single" v-model:selection="selectedEleve">
        <Column field="deb" header="Début"></Column>
        <Column field="fin" header="Fin"></Column>
        <Column field="boite" header="Boîte"></Column>
        <Column field="eleve" header="Élève"></Column>
        <Column field="lesMonos" header="Mono"></Column>
        <Column field="solde" header="Solde"></Column>
      </DataTable>
      <Paginator
        :rows="10"
        :totalRecords="countDispo"
        @page="onPaginate"
      ></Paginator>
    </div>

  </div>
</template>

<script>

import moment from "moment";
import { ref } from 'vue';

export default {

  props: [
    "putSelectEleve",
    "moniteurs"
  ],

    setup() {
    let date = ref(null) // important: utiliser ref pour la réactivité
    return { date }
  },

  components: {

  },

  data() {
    return {
        lieux : [],
        lieu : "",
        jours : "",
        laDate: "",
        dispos: [],
        countDispo : 0,
        selectedEleve : "",
        mode : "null"

    };
  },

  mounted() {
    this.getlieux();

    window.api
        .patch(
          "/agences/" + this.$store.state.user.agence.id,
          {
            autoPlanning: false,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
              "Content-Type": "application/merge-patch+json",
            },
          }
        )
        .then(() => {

        })
        .catch((error) => {
          console.log(error);
        });

  },

  methods: {

    formatDate(date) {
      const mm = String(date.month + 1).padStart(2, "0");
      const dd = String(date.day).padStart(2, "0");
      return `${date.year}-${mm}-${dd}`;
    },

    getlieux(){
      window.api
        .get("/lieus", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.lieux = response.data["hydra:member"];
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },

    getDateDispoByLieu(e){
      this.date = null;
      this.mode = "null";
      this.jours = "";
      this.laDate = "";
      this.dispos = [];
      this.countDispo = 0;

      if(e.target.value !== ""){
        window.api
          .get("/eleves/dispos/day/"+this.lieu+"/"+this.$store.state.user.agence.id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((response) => {
            this.jours = response.data.jours;
          })
          .catch((error) => {
            console.log(error.response.data.message);
          });
      }
    },

    changeLieuMono(e){
      if(e.target.value !== ""){
        if(e.target.value === "null"){
          this.onDateSelect(0, "null");
        }else{
          this.onDateSelect(0, this.mode);
        }
      }
    },

    onDateSelect(offset, mode){
      this.laDate = moment(this.date).format("DD-MM-YYYY")

        window.api
          .post(
            "/dispos/eleve/date/lieu/"+offset+"/"+mode,
            {
              date: moment(this.date).format("YYYY-MM-DD"),
              id: this.lieu,
              ida: this.$store.state.user.agence.id,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            this.dispos = response.data.eleves;
            this.countDispo = response.data.count;
          })
          .catch((error) => {
            console.log(error);
          });

    },

    onPaginate(e) {
        let offset = e.first;
        this.onDateSelect(offset, this.mode);
    },

    refreshTable() {
      if (this.laDate !== "") {
        this.onDateSelect(0, this.mode);
      }
    },

    onSelected(){
        this.$emit("putSelectEleve", this.selectedEleve);
        this.$store.commit('setShowSearchEleve', true);
        this.$store.commit('setPlanningSelectChoice', 'RESA');
        this.$store.commit('setModeResa', 'RESA ELEVE');
        this.$emit("changeDisplayApointment", true);
    },


  },



};
</script>

<style scoped>

.dispo-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 95%;
  margin: 0 auto;
}

/* ── Header ── */
.dispo-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 14px 18px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
}

.dispo-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

/* ── Selects ── */
.select-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.select-wrap svg {
  position: absolute;
  left: 10px;
  color: #94a3b8;
  pointer-events: none;
}

.form-select {
  padding: 9px 32px 9px 32px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E") no-repeat right 10px center;
  -webkit-appearance: none;
  color: #1a1f2e;
  cursor: pointer;
  outline: none;
  transition: border-color .15s, box-shadow .15s;
}

.form-select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.08);
}

/* ── Calendar ── */
.calendar-wrap {
  display: flex;
  align-items: center;
}

:deep(.p-calendar .p-inputtext) {
  padding: 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-family: inherit;
  font-size: 13px;
  color: #1a1f2e;
  outline: none;
  transition: border-color .15s, box-shadow .15s;
}

:deep(.p-calendar .p-inputtext:focus) {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.08);
}

.underlined-day {
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 3px;
  color: #1a9e6e;
  font-weight: 600;
}

/* ── Table card ── */
.table-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
}

</style>
